import React from "react";

const Ingredients = ({ name }) => {
  switch (name) {
    case "copper":
      return (
        <div className="flex md:items-center mt-8 max-w-sm copper">
          <svg
            width="100px"
            height="100px"
            viewBox="0 0 100 100"
            className="w-96"
          >
            <linearGradient
              id="copper_2"
              gradientUnits="userSpaceOnUse"
              x1="50"
              y1="100"
              x2="50"
              y2="0"
            >
              <stop offset="0" stopColor="#FD8751" />
              <stop offset="1" stopColor="#FFC37A" />
            </linearGradient>
            <path
              id="copper_1"
              d="M100,29c0-1.4-0.1-2.7-0.3-4.1c-1-6.6-3.8-12.2-8.6-16.7C85.4,2.7,78.5,0,70.7,0
	c-8.2,0-16.4,0-24.6,0c-5.7,0-11.5,0-17.3,0c-1.5,0-3,0.2-4.5,0.4c-6.2,1.1-11.6,3.9-16,8.4C2.9,14.4,0.1,21.1,0,28.9
	C0,41.3,0,53.7,0,66c0,2.4,0,4.7,0.1,7.1c0.2,4.2,1.4,8.2,3.5,11.8c5.6,9.5,14,14.7,25.1,14.9c7.1,0.2,14.2,0,21.3,0l0,0
	c6.9,0,13.8,0,20.8,0c2.2,0,4.5-0.2,6.6-0.7c7.3-1.7,13.1-5.7,17.4-11.8c3.5-5,5.2-10.6,5.2-16.6C100,56.9,100,42.9,100,29z
	 M93.7,71.8c-0.1,4.7-1.6,8.9-4.5,12.6c-3.4,4.6-8,7.5-13.6,8.8c-1.5,0.3-3.1,0.4-4.6,0.5c-5.6,0.1-11.1,0-16.6,0
	c-8.8,0-17.6,0-26.4-0.1c-4.5,0-8.6-1.6-12.2-4.2c-1.4-1.1-2.7-2.4-4-3.6c-0.2-0.2-0.3-0.4-0.5-0.7h3.8c7,0,14,0,21,0
	c8.7,0,17.4,0,26.2,0c2.7,0,5.5,0,8.2,0c4,0,7-3.1,7-7.1c0-3.7-3.2-6.8-7-6.8c-8.6,0-17.2,0-25.8,0H6.3V28.8c0.2,0,0.5,0,0.7,0h14.8
	c2.7,0,5.4,0,8.1,0c3.4,0,6.3-2.7,6.8-5.9c0.5-3.7-1.8-7.1-5.2-7.9c-0.6-0.2-1.3-0.2-2-0.2c-5.8,0-11.5,0-17.3,0h-0.7
	c0,0-0.1-0.1-0.1-0.2c0.9-0.9,1.7-1.8,2.6-2.6c4.3-3.8,9.4-5.7,15.2-5.7c6,0,12,0,17.9,0c7.9,0,15.8,0,23.6,0c6.2,0,11.5,2.2,16,6.4
	c3.7,3.6,5.9,7.9,6.7,12.9c0.2,1.2,0.3,2.5,0.3,3.7c0,7.9,0,15.9,0,23.8C93.7,59.4,93.8,65.6,93.7,71.8z M19.3,49.7
	c0-9.5,7.3-16.3,17.1-16.3c5.4,0,10,2,13,5.6l-4.7,4.3c-2.1-2.4-4.8-3.7-7.9-3.7c-5.9,0-10.1,4.1-10.1,10.1s4.2,10.1,10.1,10.1
	c3.1,0,5.8-1.3,7.9-3.7l4.7,4.3c-3,3.6-7.5,5.6-13,5.6C26.6,66,19.3,59.2,19.3,49.7z M77.5,41.3v24.2h-6.7v-2.9
	c-1.8,2.1-4.5,3.2-7.5,3.2C57.2,65.8,53,62.4,53,55V41.3h7v12.6c0,4,1.8,5.8,4.9,5.8c3.2,0,5.6-2.1,5.6-6.5v-12L77.5,41.3L77.5,41.3
	z M15.2,78.2c0-2.6,2-4.5,4.8-4.5c1.5,0,2.8,0.6,3.6,1.6l-1.3,1.2c-0.6-0.7-1.3-1-2.2-1c-1.6,0-2.8,1.2-2.8,2.8S18.4,81,20,81
	c0.9,0,1.6-0.4,2.2-1l1.3,1.2c-0.8,1-2.1,1.6-3.6,1.6C17.2,82.8,15.2,80.9,15.2,78.2z M24.2,78.2c0-2.6,2-4.5,4.8-4.5
	s4.8,1.9,4.8,4.5s-2,4.5-4.8,4.5C26.2,82.8,24.2,80.8,24.2,78.2z M31.7,78.2c0-1.7-1.2-2.8-2.7-2.8c-1.6,0-2.7,1.1-2.7,2.8
	S27.4,81,29,81C30.5,81,31.7,79.9,31.7,78.2z M42.9,77c0,2-1.5,3.2-3.8,3.2h-1.8v2.4h-2v-8.8h3.8C41.4,73.9,42.9,75.1,42.9,77z
	 M40.8,77c0-1-0.6-1.5-1.9-1.5h-1.7v3H39C40.2,78.5,40.8,78,40.8,77z M51.9,77c0,2-1.5,3.2-3.8,3.2h-1.8v2.4h-2v-8.8h3.8
	C50.4,73.9,51.9,75.1,51.9,77z M49.9,77c0-1-0.6-1.5-1.9-1.5h-1.7v3H48C49.2,78.5,49.9,78,49.9,77z M60.1,81v1.6h-6.8v-8.8H60v1.6
	h-4.6v1.9h4.1V79h-4.1v2H60.1z M67.3,82.6l-1.7-2.4h-0.1h-1.8v2.4h-2v-8.8h3.8c2.3,0,3.8,1.2,3.8,3.2c0,1.3-0.7,2.3-1.8,2.8l2,2.8
	H67.3z M65.4,75.5h-1.7v3.1h1.7c1.2,0,1.9-0.6,1.9-1.5C67.3,76.1,66.7,75.5,65.4,75.5z M20.4,24.3V26h-6.6v-1.3l3.4-3.2
	c0.8-0.7,0.9-1.2,0.9-1.6c0-0.7-0.5-1.1-1.4-1.1c-0.8,0-1.4,0.3-1.8,0.9l-1.5-1c0.7-1,1.9-1.6,3.5-1.6c2,0,3.3,1,3.3,2.6
	c0,0.9-0.2,1.6-1.5,2.8l-2,1.9L20.4,24.3L20.4,24.3z M28.3,21.4c0,3-1.8,4.7-4.5,4.7c-0.9,0-1.8-0.2-2.4-0.6l0.8-1.5
	c0.5,0.3,1,0.4,1.6,0.4c1.5,0,2.4-0.9,2.5-2.6c-0.5,0.5-1.3,0.8-2.2,0.8c-1.7,0-3-1.1-3-2.7c0-1.8,1.5-2.9,3.3-2.9
	C26.8,17,28.3,18.5,28.3,21.4z M26,19.8c0-0.8-0.6-1.3-1.5-1.3S23,19,23,19.8s0.6,1.3,1.5,1.3C25.4,21.2,26,20.6,26,19.8z"
              fill="url(#copper_2)"
            />
          </svg>

          <p className="text-white ml-4">
            <strong>Copper</strong> - an important mineral for hair and skin
            pigment due to its role in the production of melanin, assisting in
            preventing premature greying.
          </p>
        </div>
      );
    case "vitamin-c":
      return (
        <div className="flex md:items-center mt-8 max-w-sm vitc md:text-right">
          <p className="text-white mr-4">
            <strong>Vitamin C</strong> - a powerful water-soluble antioxidant
            that is involved in the production and maintenance of collagen.
          </p>
          <svg
            width="100px"
            height="100px"
            viewBox="0 0 100 100"
            className="w-96"
          >
            <linearGradient
              id="vitc"
              gradientUnits="userSpaceOnUse"
              x1="50"
              y1="0"
              x2="50"
              y2="100"
              gradientTransform="matrix(1 0 0 -1 0 102)"
            >
              <stop offset="0" stopColor="#FF9837" />
              <stop offset="1" stopColor="#FFE980" />
            </linearGradient>
            <path
              d="M28.5,43.8c0-12.4,9.5-21.2,22.3-21.2c7.1,0,13,2.6,16.9,7.3l-6.1,5.6c-2.7-3.2-6.2-4.8-10.3-4.8
	c-7.7,0-13.1,5.4-13.1,13.1s5.4,13.1,13.1,13.1c4.1,0,7.5-1.6,10.3-4.8l6.1,5.6c-3.9,4.7-9.8,7.3-16.9,7.3
	C38,65,28.5,56.2,28.5,43.8z M32.8,68L29,76.8h-2L23.2,68h2.2l2.7,6.3l2.7-6.3H32.8z M33.3,68c0-0.6,0.5-1.1,1.2-1.1
	s1.2,0.5,1.2,1.1c0,0.7-0.5,1.1-1.2,1.1C33.7,69.1,33.3,68.6,33.3,68z M33.5,70.1h2v6.7h-2V70.1z M41.6,76.5c-0.4,0.3-1,0.4-1.6,0.4
	c-1.6,0-2.5-0.8-2.5-2.4v-2.8h-1.1v-1.5h1.1v-1.6h2v1.6h1.7v1.5h-1.7v2.7c0,0.6,0.3,0.9,0.8,0.9c0.3,0,0.6-0.1,0.8-0.2L41.6,76.5z
	 M48.6,72.9v3.8h-1.8V76c-0.4,0.6-1.1,0.9-2,0.9c-1.6,0-2.5-0.9-2.5-2s0.8-2,2.9-2h1.6c0-0.8-0.5-1.3-1.6-1.3c-0.7,0-1.4,0.2-2,0.6
	l-0.7-1.4c0.7-0.5,1.8-0.8,2.9-0.8C47.5,69.9,48.6,70.9,48.6,72.9z M46.7,74.7V74h-1.4c-0.9,0-1.2,0.4-1.2,0.8
	c0,0.5,0.4,0.8,1.1,0.8C45.9,75.6,46.5,75.3,46.7,74.7z M61.8,72.9v3.9h-2v-3.6c0-1.1-0.5-1.6-1.3-1.6c-0.9,0-1.5,0.5-1.5,1.8v3.4
	h-2v-3.6c0-1.1-0.5-1.6-1.3-1.6c-0.9,0-1.5,0.5-1.5,1.8v3.4h-2V70h1.9v0.8c0.5-0.6,1.3-0.9,2.1-0.9c0.9,0,1.7,0.4,2.2,1.1
	c0.5-0.7,1.4-1.1,2.4-1.1C60.6,69.9,61.8,70.9,61.8,72.9z M63.3,68c0-0.6,0.5-1.1,1.2-1.1c0.7,0,1.2,0.5,1.2,1.1
	c0,0.7-0.5,1.1-1.2,1.1C63.8,69.1,63.3,68.6,63.3,68z M63.5,70.1h2v6.7h-2V70.1z M74.2,72.9v3.9h-2v-3.6c0-1.1-0.5-1.6-1.4-1.6
	s-1.6,0.6-1.6,1.8v3.3h-2V70h1.9v0.8c0.5-0.6,1.3-0.9,2.2-0.9C73,69.9,74.2,70.9,74.2,72.9z M50,6.3c11.7,0,22.7,4.5,30.9,12.8
	c8.2,8.2,12.8,19.2,12.8,30.9s-4.5,22.7-12.8,30.9C72.7,89.2,61.7,93.7,50,93.7s-22.7-4.5-30.9-12.8C10.8,72.7,6.3,61.7,6.3,50
	s4.5-22.7,12.8-30.9C27.3,10.8,38.3,6.3,50,6.3 M50,0C22.4,0,0,22.4,0,50s22.4,50,50,50s50-22.4,50-50S77.6,0,50,0L50,0z"
              fill="url(#vitc)"
            />
          </svg>
        </div>
      );
    case "silicon":
      return (
        <div className="flex md:items-center mt-8 max-w-sm silicon">
          <svg
            width="100px"
            height="100px"
            viewBox="0 0 100 100"
            className="w-96"
          >
            <linearGradient
              id="silicon_gradient"
              gradientUnits="userSpaceOnUse"
              x1="50"
              y1="100"
              x2="50"
              y2="0"
            >
              <stop offset="0" stopColor="#A9A9A9" />
              <stop offset="1" stopColor="#F3F3F3" />
            </linearGradient>
            <path
              d="M52.7,75.4c-1.6,0-2.7,1.1-2.7,2.8c0,1.6,1.2,2.8,2.7,2.8c1.6,0,2.7-1.1,2.7-2.8
	C55.4,76.6,54.3,75.4,52.7,75.4z M52.7,75.4c-1.6,0-2.7,1.1-2.7,2.8c0,1.6,1.2,2.8,2.7,2.8c1.6,0,2.7-1.1,2.7-2.8
	C55.4,76.6,54.3,75.4,52.7,75.4z M100,29c0-1.4-0.1-2.7-0.3-4.1c-1-6.6-3.8-12.2-8.6-16.7C85.4,2.7,78.5,0,70.7,0
	c-8.2,0-16.4,0-24.6,0c-5.7,0-11.5,0-17.3,0c-1.5,0-3,0.2-4.5,0.4C18.1,1.5,12.7,4.3,8.3,8.8C2.9,14.4,0.1,21.1,0,28.9
	C0,41.3,0,53.7,0,66c0,2.4,0,4.7,0.1,7.1c0.2,4.2,1.4,8.2,3.5,11.8c5.6,9.5,14,14.7,25.1,14.9c7.1,0.2,14.2,0,21.3,0h20.8
	c2.2,0,4.5-0.2,6.6-0.7c7.3-1.7,13.1-5.7,17.4-11.8c3.5-5,5.2-10.6,5.2-16.6C100,56.9,100,42.9,100,29z M93.7,53.2
	c0,6.2,0,12.4,0,18.6c-0.1,4.7-1.6,8.9-4.5,12.6c-3.4,4.6-8,7.5-13.6,8.8c-1.5,0.3-3.1,0.4-4.6,0.5c-5.6,0.1-11.1,0-16.6,0
	c-8.8,0-17.6,0-26.4-0.1c-4.5,0-8.6-1.6-12.2-4.2c-1.4-1.1-2.7-2.4-4-3.6c-0.2-0.2-0.3-0.4-0.5-0.7h3.8c7,0,14,0,21,0
	c8.7,0,30.8,0,33.5,0c4,0,7-3.1,7-7.1c0-3.7-3.2-6.8-7-6.8H6.3V28.8c0.2,0,0.5,0,0.7,0h14.8c2.7,0,5.4,0,8.1,0
	c3.4,0,6.3-2.7,6.8-5.9c0.5-3.7-1.8-7.1-5.2-7.9c-0.6-0.2-1.3-0.2-2-0.2h-18c0,0-0.1-0.1-0.1-0.2c0.9-0.9,1.7-1.8,2.6-2.6
	c4.3-3.8,9.4-5.7,15.2-5.7h41.6c6.2,0,11.5,2.2,16,6.4c3.7,3.6,5.9,7.9,6.7,12.9c0.2,1.2,0.3,2.5,0.3,3.7
	C93.8,37.3,93.7,45.3,93.7,53.2z M15.2,76.4c0-1.5,1.2-2.7,3.7-2.7c1.1,0,2.2,0.3,3,0.8L21.3,76c-0.8-0.5-1.6-0.7-2.4-0.7
	c-1.2,0-1.6,0.5-1.6,1c0,1.6,5.1,0.5,5.1,3.7c0,1.5-1.2,2.7-3.7,2.7c-1.4,0-2.8-0.4-3.6-1l0.7-1.5c0.7,0.5,1.8,0.9,2.9,0.9
	c1.2,0,1.7-0.4,1.7-0.9C20.3,78.5,15.2,79.7,15.2,76.4z M23.7,82.6v-8.8h2v8.8H23.7z M34.2,81v1.6h-6.4v-8.8h2V81H34.2z M35.4,82.6
	v-8.8h2v8.8H35.4z M43.8,81c0.9,0,1.6-0.4,2.2-1.1l1.3,1.2c-0.8,1-2.1,1.6-3.6,1.6c-2.7,0-4.7-1.9-4.7-4.5c0-2.7,2-4.5,4.8-4.5
	c1.5,0,2.8,0.5,3.6,1.6L46,76.5c-0.6-0.7-1.3-1-2.2-1c-1.6,0-2.8,1.1-2.8,2.8C41,79.9,42.1,81,43.8,81z M47.9,78.2
	c0-2.6,2-4.5,4.8-4.5c2.7,0,4.8,1.9,4.8,4.5c0,2.6-2,4.5-4.8,4.5C50,82.8,47.9,80.8,47.9,78.2z M59,82.6v-8.8h1.7l4.3,5.3v-5.3h2
	v8.8h-1.7L61,77.3v5.3H59z M13.5,18.8v-1.6h3.8v8.8h-2v-7.1H13.5z M23.5,22.4v-1.6h1.9v1.6h1.4v1.6h-1.4v1.8h-2v-1.8h-4.7v-1.4
	l4.1-5.5h2.1l-3.8,5.3H23.5z M55.4,78.2c0-1.7-1.2-2.8-2.7-2.8c-1.6,0-2.7,1.1-2.7,2.8c0,1.6,1.2,2.8,2.7,2.8
	C54.3,81,55.4,79.9,55.4,78.2z M38,42.9c0-2,1.7-3.6,6-3.6c2.8,0,5.8,0.8,8.7,2.5l2.3-5.5c-2.9-1.8-7-2.8-10.9-2.8
	c-9,0-13.3,4.5-13.3,9.8c0,11.7,18.3,7.6,18.3,13.5c0,2-1.8,3.4-6.1,3.4c-3.8,0-7.7-1.4-10.4-3.3l-2.5,5.5C32.9,64.5,38,66,43,66
	c9,0,13.4-4.5,13.4-9.8C56.3,44.7,38,48.7,38,42.9z M60.8,41.3v24.2h7V41.3C67.8,41.3,60.8,41.3,60.8,41.3z M64.3,30.1
	c-2.6,0-4.4,1.7-4.4,3.9s1.8,3.9,4.4,3.9c2.6,0,4.3-1.7,4.3-4.1C68.7,31.7,66.9,30.1,64.3,30.1z"
              fill="url(#silicon_gradient)"
            />
          </svg>

          <p className="text-white ml-4">
            <strong>Silicon</strong> - contributes to the structure of skin and
            collagen.
          </p>
        </div>
      );
    case "zinc":
      return (
        <div className="flex md:items-center mt-8 max-w-sm md:text-right zinc">
          <p className="text-white mr-4">
            <strong>Zinc</strong> - an antioxidant that can repair and protect
            your skin, enhances wound healing and may help boost the immune
            system.
          </p>
          <svg
            width="100px"
            height="100px"
            viewBox="0 0 100 100"
            className="w-96"
          >
            <linearGradient
              id="zinc_gradient"
              gradientUnits="userSpaceOnUse"
              x1="50"
              y1="0"
              x2="50"
              y2="100"
            >
              <stop offset="0" stopColor="#E8EAFF" />
              <stop offset="1" stopColor="#A9AAB9" />
            </linearGradient>
            <path
              d="M25,18.7c-1,0-1.7,0.8-1.7,2.8s0.7,2.8,1.7,2.8c1,0,1.7-0.8,1.7-2.8C26.8,19.6,26.1,18.7,25,18.7z
	 M25,18.7c-1,0-1.7,0.8-1.7,2.8s0.7,2.8,1.7,2.8c1,0,1.7-0.8,1.7-2.8C26.8,19.6,26.1,18.7,25,18.7z M25,18.7c-1,0-1.7,0.8-1.7,2.8
	s0.7,2.8,1.7,2.8c1,0,1.7-0.8,1.7-2.8C26.8,19.6,26.1,18.7,25,18.7z M25,18.7c-1,0-1.7,0.8-1.7,2.8s0.7,2.8,1.7,2.8
	c1,0,1.7-0.8,1.7-2.8C26.8,19.6,26.1,18.7,25,18.7z M100,29c0-1.4-0.1-2.7-0.3-4.1c-1-6.6-3.8-12.2-8.6-16.7C85.4,2.7,78.5,0,70.7,0
	c-8.2,0-16.4,0-24.6,0c-5.7,0-11.5,0-17.3,0c-1.5,0-3,0.2-4.5,0.4C18.1,1.5,12.7,4.3,8.3,8.8C2.9,14.4,0.1,21.1,0,28.9
	C0,41.3,0,53.7,0,66c0,2.4,0,4.7,0.1,7.1c0.2,4.2,1.4,8.2,3.5,11.8c5.6,9.5,14,14.7,25.1,14.9c7.1,0.2,14.2,0,21.3,0h20.8
	c2.2,0,4.5-0.2,6.6-0.7c7.3-1.7,13.1-5.7,17.4-11.8c3.5-5,5.2-10.6,5.2-16.6C100,56.9,100,42.9,100,29z M93.7,53.2
	c0,6.2,0,12.4,0,18.6c-0.1,4.7-1.6,8.9-4.5,12.6c-3.4,4.6-8,7.5-13.6,8.8c-1.5,0.3-3.1,0.4-4.6,0.5c-5.6,0.1-11.1,0-16.6,0
	c-8.8,0-17.6,0-26.4-0.1c-4.5,0-8.6-1.6-12.2-4.2c-1.4-1.1-2.7-2.4-4-3.6c-0.2-0.2-0.3-0.4-0.5-0.7h3.8c7,0,14,0,21,0
	c8.7,0,12.8,0,15.6,0c4,0,7-3.1,7-7.1c0-3.7-3.2-6.8-7-6.8h-3.3c0,0-0.7,0-3.7,0H6.3V28.8c0.2,0,0.5,0,0.7,0h14.8c2.7,0,5.4,0,8.1,0
	c3.4,0,6.3-2.7,6.8-5.9c0.5-3.7-1.8-7.1-5.2-7.9c-0.6-0.2-1.3-0.2-2-0.2h-18c0,0-0.1-0.1-0.1-0.2c0.9-0.9,1.7-1.8,2.6-2.6
	c4.3-3.8,9.4-5.7,15.2-5.7h41.6c6.2,0,11.5,2.2,16,6.4c3.7,3.6,5.9,7.9,6.7,12.9c0.2,1.2,0.3,2.5,0.3,3.7
	C93.8,37.3,93.7,45.3,93.7,53.2z M18.4,75.5v-1.6h7.4v1.3L21,81h5v1.6h-7.7v-1.3l4.8-5.8H18.4z M27.3,82.6v-8.8h2v8.8H27.3z
	 M31.3,82.6v-8.8H33l4.3,5.3v-5.3h2v8.8h-1.7l-4.4-5.3v5.3H31.3z M45.8,81c0.9,0,1.6-0.4,2.2-1.1l1.3,1.2c-0.8,1-2.1,1.6-3.6,1.6
	c-2.7,0-4.7-1.9-4.7-4.5c0-2.7,2-4.5,4.8-4.5c1.5,0,2.8,0.5,3.6,1.6L48,76.5c-0.6-0.7-1.3-1-2.2-1c-1.6,0-2.8,1.1-2.8,2.8
	C43,79.9,44.1,81,45.8,81z M16.7,22.2h-0.9v-1.3l1.8-2h-3.7v-1.6H20v1.3l-2,2.3c1.6,0.2,2.4,1.2,2.4,2.5c0,1.5-1.1,2.8-3.6,2.8
	c-1.2,0-2.5-0.4-3.3-0.9l0.8-1.6c0.7,0.5,1.6,0.8,2.5,0.8c1,0,1.6-0.4,1.6-1.1C18.3,22.6,17.8,22.2,16.7,22.2z M21.3,21.5
	c0-2.9,1.6-4.5,3.8-4.5s3.8,1.6,3.8,4.5s-1.6,4.5-3.8,4.5S21.3,24.4,21.3,21.5z M25,24.4c1,0,1.7-0.8,1.7-2.8s-0.7-2.8-1.7-2.8
	s-1.7,0.8-1.7,2.8C23.4,23.5,24,24.4,25,24.4z M25,18.7c-1,0-1.7,0.8-1.7,2.8s0.7,2.8,1.7,2.8c1,0,1.7-0.8,1.7-2.8
	C26.8,19.6,26.1,18.7,25,18.7z M25,18.7c-1,0-1.7,0.8-1.7,2.8s0.7,2.8,1.7,2.8c1,0,1.7-0.8,1.7-2.8C26.8,19.6,26.1,18.7,25,18.7z
	 M25,18.7c-1,0-1.7,0.8-1.7,2.8s0.7,2.8,1.7,2.8c1,0,1.7-0.8,1.7-2.8C26.8,19.6,26.1,18.7,25,18.7z M25,18.7c-1,0-1.7,0.8-1.7,2.8
	s0.7,2.8,1.7,2.8c1,0,1.7-0.8,1.7-2.8C26.8,19.6,26.1,18.7,25,18.7z M30.7,59.6l17.2-20.8V34H21.4v5.9h16.9L21.1,60.8v4.7h27.5v-5.9
	L30.7,59.6L30.7,59.6z M67.5,40.9c-3.3,0-6.1,1.1-8,3.2v-2.8h-6.7v24.2h7v-12c0-4.5,2.4-6.5,5.8-6.5c3.1,0,4.9,1.8,4.9,5.7v12.8h7
	V51.7C77.5,44.2,73.2,40.9,67.5,40.9z"
              fill="url(#zinc_gradient)"
            />
          </svg>
        </div>
      );
    case "vitamin-b7":
      return (
        <div className="flex md:items-center mt-8 max-w-sm b7">
          <svg
            width="100px"
            height="100px"
            viewBox="0 0 100 100"
            className="w-96"
          >
            <linearGradient
              id="b7_gradient"
              gradientUnits="userSpaceOnUse"
              x1="50"
              y1="0"
              x2="50"
              y2="100"
            >
              <stop offset="0" stopColor="#EFD8B5" />
              <stop offset="1" stopColor="#D0AD79" />
            </linearGradient>
            <path
              d="M61.9,50.5c0,6.6-5.2,10.4-15.3,10.4H26.7V22.7h18.7c9.6,0,14.5,4,14.5,10
	c0,3.8-2,6.8-5.1,8.4C59.1,42.5,61.9,45.7,61.9,50.5z M35.6,29.4v9h8.8c4.3,0,6.7-1.5,6.7-4.5s-2.3-4.5-6.7-4.5H35.6z M53,49.6
	c0-3.2-2.5-4.8-7.1-4.8H35.6v9.5h10.4C50.5,54.3,53,52.9,53,49.6z M32.8,66.1L29,74.8h-2l-3.8-8.8h2.2l2.7,6.3l2.7-6.3H32.8z
	 M33.3,66.1c0-0.6,0.5-1.1,1.2-1.1s1.2,0.5,1.2,1.1c0,0.7-0.5,1.1-1.2,1.1C33.8,67.2,33.3,66.7,33.3,66.1z M33.5,68.1h2v6.7h-2V68.1
	z M41.6,74.5c-0.4,0.3-1,0.4-1.6,0.4c-1.6,0-2.5-0.8-2.5-2.4v-2.8h-1.1v-1.5h1.1v-1.6h2v1.6h1.7v1.5h-1.7v2.7c0,0.6,0.3,0.9,0.8,0.9
	c0.3,0,0.6-0.1,0.8-0.2L41.6,74.5z M48.7,71v3.8h-1.8V74c-0.4,0.6-1.1,0.9-2,0.9c-1.6,0-2.5-0.9-2.5-2s0.8-2,2.9-2h1.6
	c0-0.8-0.5-1.3-1.6-1.3c-0.7,0-1.4,0.2-2,0.6l-0.7-1.4c0.7-0.5,1.8-0.8,2.9-0.8C47.5,68,48.7,69,48.7,71z M46.7,72.7V72h-1.3
	c-0.9,0-1.2,0.4-1.2,0.8c0,0.5,0.4,0.8,1.1,0.8S46.5,73.3,46.7,72.7z M61.8,71v3.9h-2v-3.6c0-1.1-0.5-1.6-1.3-1.6
	c-0.9,0-1.5,0.5-1.5,1.8v3.4h-2v-3.6c0-1.1-0.5-1.6-1.3-1.6c-0.9,0-1.5,0.5-1.5,1.8v3.4h-2V68h1.9v0.8c0.5-0.6,1.3-0.9,2.1-0.9
	c0.9,0,1.7,0.4,2.2,1.1c0.5-0.7,1.4-1.1,2.4-1.1C60.7,68,61.8,68.9,61.8,71z M63.3,66.1c0-0.6,0.5-1.1,1.2-1.1
	c0.7,0,1.2,0.5,1.2,1.1c0,0.7-0.5,1.1-1.2,1.1C63.8,67.2,63.3,66.7,63.3,66.1z M63.6,68.1h2v6.7h-2V68.1z M74.2,71v3.9h-2v-3.6
	c0-1.1-0.5-1.6-1.4-1.6c-0.9,0-1.6,0.6-1.6,1.8v3.3h-2v-6.7h1.9v0.8c0.5-0.6,1.3-0.9,2.2-0.9C73,68,74.2,68.9,74.2,71z M50,6.3
	c11.7,0,22.7,4.5,30.9,12.8c8.2,8.2,12.8,19.2,12.8,30.9s-4.5,22.7-12.8,30.9C72.7,89.2,61.7,93.7,50,93.7s-22.7-4.5-30.9-12.8
	C10.8,72.7,6.3,61.7,6.3,50s4.5-22.7,12.8-30.9C27.3,10.8,38.3,6.3,50,6.3 M50,0C22.4,0,0,22.4,0,50c0,27.6,22.4,50,50,50
	s50-22.4,50-50S77.6,0,50,0L50,0z M79.8,42.4v3l-7.3,16.7h-5l7.1-16h-6.5v3.2H64v-6.9L79.8,42.4L79.8,42.4z"
              fill="url(#b7_gradient)"
            />
          </svg>

          <p className="text-white ml-4">
            <strong>Biotin</strong> - increases nail thickness and may reduce
            the risk of nail splitting.
          </p>
        </div>
      );
    default:
      return;
  }
};

export default Ingredients;
